import { type ReactNode } from "react";

import { cn } from "@trip/utils";

export function Prose({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "[&_a_u]:text-prune-500",
        "[&_p]:mb-2 sm:[&_p]:mb-3",
        "[&_.tour]:my-4 sm:[&_.tour]:my-6",
        // "[&_h1]:mb-4 [&_h1]:text-3xl [&_h1]:leading-tight [&_h1]:tracking-tight sm:[&_h1]:text-4xl",
        "[&_h1]:mb-4 [&_h1]:text-xl [&_h1]:tracking-tight sm:[&_h1]:text-2xl",
        "[&_h2]:mb-3 [&_h2]:mt-2 [&_h2]:text-lg [&_h2]:font-medium [&_h2]:leading-tight [&_h2]:tracking-tight sm:[&_h2]:text-xl",
        "[&_h3]:mb-3 [&_h3]:text-base sm:[&_h3]:text-lg",
        "[&_ol]:mb-3 [&_ul]:mb-3",
        "[&_li_p]:mb-0 [&_li_p]:inline",
        "[&_li]:ml-6 [&_li]:leading-snug [&_ul_li]:list-disc",
        "[&_ol_li]:list-decimal",
        "[&_blockquote]:mb-2 [&_blockquote]:rounded-xl [&_blockquote]:bg-neutral-200 [&_blockquote]:p-4 sm:[&_blockquote]:p-6 [&_blockquote_:last-child]:mb-0",
        "[&_blockquote_footer]:font-medium",
        className,
      )}
    >
      {children}
    </div>
  );
}
